/*
 * @providesModule SKZLayoutAnimations
 *
 */

import {LayoutAnimation as RNLayoutAnimation} from 'react-native';

const SKZLayoutAnimations = {
  /**
   * The react-native preset LayoutAnimation.easeInEaseOut() causes the Modal to repop and freeze.
   * This is a temporary replacement till the issue is resolved from react-native end. See:
   * https://skillzinc.atlassian.net/browse/RP-1614
   */
  easeInEaseOut: (
    duration = 300,
    onAnimationDidEnd?: () => void,
    onAnimationDidFail?: () => void
  ) => {
    RNLayoutAnimation.configureNext(
      {
        duration,
        update: {type: RNLayoutAnimation.Types.easeInEaseOut},
      },
      onAnimationDidEnd,
      onAnimationDidFail
    );
  },
};

export default SKZLayoutAnimations;
